import { Component, Input } from '@angular/core';

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

@Component({
  selector: 'app-page-hero-redesign',
  templateUrl: './page-hero-redesign.component.html',
  styleUrls: ['./page-hero-redesign.component.scss']
})
export class PageHeroRedesignComponent {

  @Input() title = '';

  @Input() backgroundImage = '';

  @Input() breadcrumbs: BreadcrumbItem[] = [];

  trackByLabel(index: number, item: BreadcrumbItem): string {
    return item.label;
  }

}